// Function to get URL parameters
function getUrlParam(name: string): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

// Offline by default (e.g. the GitHub Pages build). Pass ?server=<url> to connect
// to a live Colyseus server instead (e.g. ?server=ws://localhost:2567 for dev).
const serverUrl = getUrlParam('server');

export const OFFLINE = !serverUrl;
export const BACKEND_URL = serverUrl || '';
